import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PaymentRequestSummaryModel} from '../../entity/paymentRequestSummary.model';
import {PAYMENT_REQUEST_STATUS, PaymentRequestModel} from '../../entity/paymentRequest.model';
import {PaymentRequestFindOneByIdService} from "../../../impl/service/paymentRequestFindOneById.service";

@Component({
    selector: 'app-payment-request-summary',
    templateUrl: './payment-request-summary.component.html',
    providers: [
        PaymentRequestFindOneByIdService,
    ]
})
export class PaymentRequestSummaryComponent implements OnChanges {

    @Input() entity: PaymentRequestSummaryModel | PaymentRequestModel;
    @Input() hideTitle = false;
    @Input() expanded = false;

    PaymentRequestStatus = PAYMENT_REQUEST_STATUS;
    summary: PaymentRequestSummaryModel;
    plain: PaymentRequestModel;

    constructor(public findOneByIdService: PaymentRequestFindOneByIdService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.entity instanceof PaymentRequestSummaryModel) {
            this.summary = this.entity;
        } else {
            this.plain = this.entity;
            this.summary = this.entity.summary;
        }

        if (changes['expanded']) {
            if (this.expanded) {
                this.onExpanded();
            }
        }
    }

    onExpanded() {
        if (!this.plain) {
            this.findOneByIdService.loadEntity(this.summary.id)
                .then((result) => this.plain = result);
        }
    }


}
